import { render, staticRenderFns } from "./WSCLIENT.vue?vue&type=template&id=8b03c64a"
import script from "./WSCLIENT.vue?vue&type=script&lang=js"
export * from "./WSCLIENT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports